<template>
  <el-table-column
    prop="central_invoice.invoice_number"
    sortable="custom"
    label="Számla"
    show-overflow-tooltip
    min-width="210"
  >
    <template slot-scope="scope">
      <div
        v-if="scope.row.invoice_receipt_number && scope.row.invoice_type === 'App\\Invoice'"
        style="display: inline-block;"
      >
        <receipt-link
          :id="scope.row.invoice_id"
          :label="scope.row.invoice_receipt_number"
          type="invoice"
        />
      </div>
      <div
        v-if="scope.row.representative_receipt_number && scope.row.invoice_type === 'App\\RepresentativeSale'"
        style="display: inline-block;"
      >
        <receipt-link
          :id="scope.row.invoice_id"
          :label="scope.row.representative_receipt_number"
          type="representativeSale"
        />
      </div>
      <el-tag
        v-if="!scope.row.representative_receipt_number && !scope.row.invoice_receipt_number"
        size="small" type="warning"
      >
        Nincs kapcsolódó számla
      </el-tag>
    </template>
  </el-table-column>
</template>

<script>
import ReceiptLink from '../../../utils/ReceiptLink';

export default {
  components: { ReceiptLink },
  propName: 'central_invoice.invoice_number',
  methods: {
    openReceipt(row) {
      window.open(row.invoice.invoice_file.path);
    },
  },
};
</script>

